module.exports = __webpack_public_path__ + "img/sika.640224c4.svg";